(function () {
  'use strict';

  angular
    .module('web2print.recipients')
    .directive('senderForm', senderForm);

  /* @ngInject */
  function senderForm () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/recipients/forms/sender-form.directive.html'
    };

    return directive;
  }
})();
